module.exports = __webpack_public_path__ + "static/media/conagra.09078c25.jpg";